import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { MailWarning, X } from "lucide-react";

const DISMISS_KEY = "p2w-verify-banner-dismissed";

export default function VerifyEmailBanner() {
    const { user } = useAuth();
    const location = useLocation();
    const [dismissed, setDismissed] = useState(() => {
        try { return sessionStorage.getItem(DISMISS_KEY) === "1"; } catch { return false; }
    });

    // Reset dismissed state when user changes (e.g., logout)
    useEffect(() => {
        if (!user || user === false) setDismissed(false);
    }, [user]);

    if (!user || user === false) return null;
    if (user.email_verified) return null;
    if (dismissed) return null;
    // Don't show the banner on the verify-email page itself
    if (location.pathname === "/verify-email") return null;

    const onDismiss = () => {
        setDismissed(true);
        try { sessionStorage.setItem(DISMISS_KEY, "1"); } catch { /* noop */ }
    };

    return (
        <div
            data-testid="verify-email-banner"
            className="bg-gradient-to-r from-p2w-purple/15 via-p2w-green/10 to-transparent border-b border-p2w-line/60"
        >
            <div className="max-w-7xl mx-auto px-4 py-2.5 flex items-center gap-3">
                <MailWarning className="w-4 h-4 text-p2w-green shrink-0" />
                <p className="text-sm text-white/90 flex-1">
                    <span className="font-semibold">Verifica tu email</span>{" "}
                    <span className="text-p2w-gray hidden sm:inline">
                        para asegurar tu cuenta y recibir notificaciones de pagos.
                    </span>
                </p>
                <Link
                    to={`/verify-email?email=${encodeURIComponent(user.email)}`}
                    className="text-xs font-semibold px-3 py-1.5 rounded-full bg-p2w-green text-p2w-green-fg hover:bg-p2w-green/90 transition-colors whitespace-nowrap"
                    data-testid="verify-banner-cta"
                >
                    Verificar ahora
                </Link>
                <button
                    onClick={onDismiss}
                    aria-label="Cerrar"
                    data-testid="verify-banner-dismiss"
                    className="text-p2w-gray hover:text-white transition-colors"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
}
